export default [
  {
    path: "/areas",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "areas_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Areas", to: "areas_list" }],
          permission: "area:view",
          title: "Areas"
        }
      },
      {
        name: "areas_arvore",
        path: "arvore",
        component: () => import("./pages/Arvore"),
        meta: {
          breadcrumbs: [{ label: "Areas", to: "areas_arvore" }],
          permission: "area:view",
          title: "Areas - Estrutura"
        }
      },
      {
        name: "areas_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "Areas", to: "areas_list" }],
          permission: "area:create",
          title: "Areas - Cadastro"
        }
      },
      {
        name: "areas_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "Areas", to: "areas_list" }],
          permission: "area:edit",
          title: "Areas - Edição"
        }
      }
    ]
  }
];
